const OPTIONS = [
  { label: 'Si.', value: 'si' },
  { label: 'No.', value: 'no' },
  { label: 'No aplica', value: 'no aplica' },
];

function EvaluationQuestionCard({
  question,
  titlePrefix = 'Evaluacion',
  moduleLabel = 'TRIANUAL',
  currentStepLabel,
  totalQuestions,
  onAnswerChange,
}) {
  const progressWidth = `${(Number(currentStepLabel) / totalQuestions) * 100}%`;

  return (
    <section className="rounded-[16px] border-2 border-[#2dbf63] bg-white p-4 shadow-[0_6px_20px_rgba(15,23,42,0.08)] sm:p-5">
      <h2 className="font-login text-[22px] font-bold leading-tight text-[#212121] sm:text-[28px]">
        {titlePrefix} de {moduleLabel}
      </h2>

      <div className="mt-4 flex items-center justify-between gap-4 font-login text-[14px] font-bold text-[#2d2d2d] sm:text-[16px]">
        <p>Pregunta: {currentStepLabel}/{totalQuestions}</p>
        <p>Total: {totalQuestions}</p>
      </div>

      <div className="mt-2 h-[18px] rounded-[2px] border border-[#232b99] bg-white p-[2px]">
        <div
          className="h-full bg-[#131a88]"
          style={{ width: progressWidth }}
        />
      </div>

      <p className="mt-4 font-login text-[18px] font-bold uppercase leading-[1.2] text-[#232323] sm:text-[22px]">
        {question.pregunta}
      </p>

      <div className="mt-6 space-y-5">
        {OPTIONS.map((option) => (
          <label
            key={option.value}
            className="flex cursor-pointer items-center gap-3 font-login text-[18px] font-medium text-[#232323]"
          >
            <span>{option.label}</span>
            <input
              type="radio"
              name={`pregunta-${question.id}`}
              checked={question.respuesta === option.value}
              onChange={() => onAnswerChange(option.value)}
              className="h-5 w-5 accent-[#4a58ff]"
            />
          </label>
        ))}
      </div>
    </section>
  );
}

export default EvaluationQuestionCard;
